module.exports = {
  message: {
    Language: '简',
    Home: '首页',
    CompanyIntroduction: '公司介绍',
    CompanyCulture: '企业文化',
    News: '新闻资讯',
    ContactUs: '联系我们',
    CeBaRelatedPlatform: '测吧相关平台',
    FollowUs: '关注我们',
    ContactInformation: '联系方式',
    joinUs: '加入我们',
    socialRecruitment: '社会招聘',
    CampusRecruiting: '校园招聘',
    JobSelf_recommendation: '职位自荐',
    contactUs: '联系我们',
    customerService: '客户服务',
    CooperationMeeting: '合作洽谈',
    LegalInformation: '法律信息',
    ServiceAgreement: '服务协议',
    PrivacyPolicy: '隐私政策',
    InvoiceAndQualityCertificateQueryPlatform: '质博士',
    OnlineVerificationPlatformFor: '电子文件签名验证平台',
    ElectronicSignatureDocume: '电子文件服务平台',
    CompanyProfile: '公司简介',
    DevelopmentPath: '发展历程',
    QualificationHonor: '资质荣誉',
    Partner: '合作伙伴',
    CompanyProfileP1: '测吧，是以质量为核心要素的互联网基础设施与服务平台，通过“开放平台+信息智能平台+业务定制平台”的方式，为企业和个人提供以质量信息服务。',
    CompanyProfileP2: '我们的愿景是做真实质量信息的传递者，履行着让品质带来欢乐的使命。',
    CompanyProfileP3: '我们的业务有来签云平台、企查查：',
    CompanyProfileP4: '来签云平台',
    CompanyProfileP5: '企业和个人的契约身份证发放，真实信息文件的签约，验证，并建立可阅可信的商品质量标准和合同文书，提升企业经营和供应链管理效率、以及强化个人契约安全保障',
    CompanyProfileP6: '企查查',
    CompanyProfileP7: '通过互联网手段，为企业提供真实有效的质量信息，深挖、创新业务，提供质量信息场景应用服务',
    CompanyProfileP8: `我们的合作伙伴包括《电子签名法》的颁发者：国家认监委、3C产品行业标准的建立者：工业富联商超的头部玩家：华润万家、国内仅有的四大国际CA颁发机构之一：上海市数字证书认证中心等。`,
    Vision: '愿景',
    Mission: '使命',
    Value: '价值观',
    CompanyCultureMission: `真实质量信息的形成与传递关乎生产企业、卖场、电商平台、检验检测认证机构、消费者和其它类型企业在内的所有参与者的利益。市场行为叠加消费者的消费心理和习惯，造成产品质量信息的传递过程和结果是扭曲和不真实的，我们深信让消费者随时、随地、随心的接收到真实的产品质量信息，并参与、监督、讨论产品质量，有利于改变消费者的消费心理和习惯，增强企业提升产品质量和持续创新的动力。`,
    CompanyCultureVision: `我们为生产企业、卖场、电商平台、检验检测认证机构、消费者和其它类型企业在内的所有参与者提供 以质量为核心要素的互联网基础设施与服务平台，让参与者得到有价值的服务，并借助新技术的力量加强互动，共同来提升品质、享受品质带来的欢乐，并进入良性互动循环。同时我们不断创新与融合以质量为核心要素的各项服务，更好的服务所有参与者。`,
    CompanyCultureValueP1: `我们相信，强大的共同价值观是塑造公司的企业文化、公司发展壮大及永续经营的基石。 测吧的价值观对于我们如何经营业务、招揽人才、考核员工以及决定员工报酬事宜扮演着重要的角色：`,
    CompanyCultureValueP2: `1、 客户至上：客户是公司存在的唯一理由 `,
    CompanyCultureValueP3: `2、 勇于创新：勇于改变，持续创新 `,
    CompanyCultureValueP4: `3、 团队合作：尊重差异、敢于担当 `,
    CompanyCultureValueP5: `4、 梦想：绽放生命、永不言弃 `,
    CompanyCultureValueP6: `5、 诚信：真诚坦荡、知行合一 `,
    CompanyCultureValueP7: `6、 工作：敬业执着、精益求精`,
    CompanyNews: '公司动态',
    IndustryNews: '行业新闻',
    customerServiceArticleP1: `我们相信，强大的共同价值观是塑造公司的企业文化、公司发展壮大及永续经营的基石。 测吧的价值观对于我们如何经营业务、招揽人才、考核员工以及决定员工报酬扮演着重要的角色：`,
    customerServiceArticleP2: `1、 客户至上：客户是公司存在的唯一理由 `,
    customerServiceArticleP3: `2、 勇于创新：勇于改变，持续创新`,
    customerServiceArticleP4: `3、 团队合作：尊重差异、敢于担当 `,
    customerServiceArticleP5: `4、 梦想：绽放生命、永不言弃`,
    customerServiceArticleP6: `5、 诚信：真诚坦荡、知行合一 `,
    customerServiceArticleP7: `6、 工作：敬业执着、精益求精`,
    CooperationMeetingArticleP1: `商务与技术`,
    CooperationMeetingArticleP2: `上海总部:`,
    CooperationMeetingArticleP3: `地址:上海市闵行区恒西路189号爱登堡大厦7F`,
    CooperationMeetingArticleP4: `电话：021-34799100`,
    CooperationMeetingArticleP5: `传真：021-34799101`,
    CooperationMeetingArticleP6: `实施与细节`,
    CooperationMeetingArticleP7: `武汉研发中心：`,
    CooperationMeetingArticleP8: `地址:湖北省武汉市江夏区流芳街道光谷金融港汇金中心1号楼2F`,
    CooperationMeetingArticleP9: ` 电话：027-63495881`,
    CooperationMeetingArticleP10: `传真：027-63495882`,
    August2019: `2019年8月`,
    August2019Event: `质博士上线（质量及相关信息查询与应用平台）`,
    April2019: `2019年4月`,
    April2019Event: `来签上线（电子文件签名云平台）`,
    December2018: `2018年12月`,
    December2018Event: `质链网上线（富士康科技集团供应链品质安全管控平台）`,
    July2018: `2018年7月`,
    July2018Event: `对接《CNCA自我声明符合性信息报送系统》(3C自我声明认证、国推ROHS认证及其他自我声明认证)`,
    June2018: `2018年6月`,
    June2018Event: `对接《CMA检验检测机构资质认定网上审批系统》《CNAS实验室/检验机构认可业务管理系统》`,
    May2018: `2018年5月`,
    May2018Event: `检验检测认证行业电子文件服务平台上线`,
    December2017: `2017年12月`,
    December2017Event: `国家认监委电子文件签名验证平台上线（测吧设计并运维）`,
    June2017: `2017年6月`,
    June2017Event: `在上海召开产品新闻发布会`,
    May2017: `2017年5月`,
    May2017Event: `与国家认监委信息中心签署战略合作协议`,
    May2016: `2016年5月`,
    May2016Event: `来签系列产品上线（电子文件电子签名系统）`,
    loadMore: `加载更多`,
    hotLine: `客服热线:`,
    curtomerCenterP1: `测吧客服中心是公司所有业务的主要服务窗口，负责向客户解答相关的业务咨询及受理各种投诉。客服中心致力于不断完善服务运维体系，向广大用户提供全方位、及时周到的服务，包括提供热线服务、在线回复，网上业务信息安全审核等。以实现建造一流的客服中心、培养一流的客服专业人才与测吧一起进步共同成长的愿景。
    `,
    curtomerCenterP2: `优秀的客服管理团队以及专业化客服人员将为您提供全面、贴心、及时的优质金牌服务。`,
    homeintroduce: `测吧：品质带来欢乐`,
    homeIntroduceText: `我们通过“开放平台+信息智能平台+业务定制平台”的方式，构建以质量为核心要素的互联网基础设施与服务平台，赋能企业，帮助其供应链品质管控安全可信，提质增效。同时生产企业、卖场、电商平台、检验检测认证机构、消费者和其它类型企业在内的所有参与者借助新技术的力量进行互动，共同来提升品质、享受品质带来的欢乐，并进入良性互动循环`,
    platform: `测吧平台`,
    toSign: `来签`,
    toSignIntroduce: `电子文件签名云平台，为企业和个人提供[实名认证]、[在线签署]、[意愿验证]、[文件管理]、[证据链保存]、[诉讼保障]、[保险赔付]等电子文件全生命周期智能管理服务。借助电脑、手机、平板等设备，随时随地完成电子文件的实时签署并确保其安全、合规、不可篡改。`,
    servicePlatform: `检验检测认证行业电子文件服务平台`,
    servicePlatformIntroduce: `与中国国家认证认可监督管理委员会信息中心（已更改为国家市场监督管理总局信息中心）战略合作，专业服务于检验检测认证行业和国家认监委相关系统。提供标准查询、资讯、产品质量报告与认证证书电子化、政务系统文件流转电子化等服务。`,
    DrQuality: `质博士`,
    DrQualityIntroduce: `以质量为核心要素的相关信息查询与应用平台，向企业和个人展示真实可信的产品质量和产品质量的保障能力，同时为制造领域与流通领域的供应链品质管控与质量提升提供技术基础设施服务。`,
    cooperationPlatform: `合作平台`,
    OnlineVerificationPlatformForIntroduce: `中国国家认证认可监督管理委员会设计的第三方电子文件签名权威验证平台，用于验证电子文件签名是否被假冒、是否被篡改，解决了电子文件签名在互联网流通过程中无法辨别真伪的现实问题，由测吧承建并运维。`,
    QualityChainNetwork: `质链网`,
    QualityChainNetworkIntroduce: `质链网：富士康科技集团与测吧共同承建的供应链质量安全管控平台，提升供货商管理综效，助力供货商提质增效，同时赋能上游供应链企业以及富士康工业互联网技术与云平台。`,
    introductionCompanyProfile: `测吧通过“开放平台+信息智能平台+业务定制平台”的方式，构建以质量为核心要素的互联网基础设施与服务平台，赋能企业，帮助其供应链品质管控安全可信，提质增效。同时生产企业、卖场、电商平台、检验检测认证机构、消费者和其它类型企业在内的所有参与者借助新技术的力量进行互动，共同来提升品质、享受品质带来的欢乐，并进入良性互动循环。`,
    introductionOfToSign: `来签：电子文件签名云平台，为企业和个人提供「实名认证」、「在线签署」、「意愿验证」、「文件管理」、「证据链保存」、「诉讼保障」、「保险赔付」等电子文件全生命周期智能管理服务。借助电脑、手机、平板等设备，随时随地完成电子文件的实时签署并确保其安全、合规、不可篡改。`,
    introductionOfElectronicSignatureDocume: `检验检测认证行业电子文件服务平台：与中国国家认证认可监督管理委员会信息中心（已更改为国家市场监督管理总局信息中心）战略合作，专业服务于检验检测认证行业和国家认监委相关系统。提供标准查询、资讯、产品质量报告与认证证书电子化、政务系统文件流转电子化等服务。`,
    introductionOfDrQuality: `质博士：以质量为核心要素的相关信息查询与应用平台，向企业和个人展示真实可信的产品质量和产品质量的保障能力，同时为制造领域与流通领域的供应链品质管控与质量提升提供技术基础设施服务`,
    introductionOfOnlineVerificationPlatformFor: `电子文件签名验证平台：中国国家认证认可监督管理委员会设计的第三方电子文件签名权威验证平台，用于验证电子文件签名是否被假冒、是否被篡改，解决了电子文件签名在互联网流通过程中无法辨别真伪的现实问题，由测吧承建并运维。`,
    introductionOfQualityChainNetwork: `质链网：富士康科技集团与测吧共同承建并运维的供应链品质安全管控平台，提升供货商管理综效，助力供货商提质增效，同时赋能上游供应链企业以及富士康工业互联网技术与云平台。`,
    QualityBringsJoys: `品质带来欢乐`,
    HeraldOfTrueQuality: `真实质量信息的传递者`,
    sell: `销售`,
    UIDesigner: `UI设计师`,
    Front_endDevelopmentEngineer: `前端开发`,
    JAVAEngineer: `JAVA工程师`,
    JobRequirements: `职位要求`,
    sellJobRequirements1: ` 1、大专以上学历；`,
    sellJobRequirements2: `2、具备良好的电话开发客户的技巧；`,
    sellJobRequirements3: `3、有1年以上电话销售经验；`,
    sellJobRequirements4: `4、性格外向，能在压力下工作；`,
    sellJobRequirements5: `5、沟通能力强，解决问题能力强；`,
    sellJobRequirements6: `6、接受优秀应届毕业生，有强烈的意愿从事销售工作，敢于挑战，抗压力强；`,
    JobResponsibilities: `岗位职责`,
    sellDuty1: `1、开发检验、鉴定、测试与认证领域的信息化业务`,
    sellDuty2: `2、维护已开发老客户并保持良好的关系。`,
    UIDesignerJobRequirements1: ` 1、对色彩运用有良好的基础，注重用户体验，具备较强的审美能力，有较高的平面、美术设计水平;`,
    UIDesignerJobRequirements2: ` 2、学习能力强，能独立思考，有良好的创意思维和理解能力，富有创新精神;`,
    UIDesignerJobRequirements3: ` 3、精通Photoshop、Dreamweaver、Flash等常用设计软件，精通DIV CSS，对HTML5有一定了解的优先;`,
    UIDesignerJobRequirements4: ` 4、三年以上的平面设计，网页设计相关工作经验;`,
    UIDesignerJobRequirements5: ` 5、应聘者需提供优秀设计作品2-3个。`,
    UIDesignerDuty1: `1、参与项目前期界面视觉研究、互动体验设计。`,
    UIDesignerDuty2: `2、参与项目进度进行UI设计。`,
    UIDesignerDuty3: `3、根据研发进度改写UI设计流程图以及进度表。`,
    Front_endDevelopmentEngineerJobRequirements1: `1、三年以上前端页面制作经验；`,
    Front_endDevelopmentEngineerJobRequirements2: `2、精通DIV CSS网页布局、Html、CSS样式表，熟悉Web2.0标准，能够解决浏览器兼容问题；`,
    Front_endDevelopmentEngineerJobRequirements3: `3、熟悉W3C标准，对表现与数据分离、Web语义化等有深刻理解；`,
    Front_endDevelopmentEngineerJobRequirements4: `4、对常见的前端性能问题有清晰的认识，能够主导前端的性能优化；`,
    Front_endDevelopmentEngineerJobRequirements5: `5、熟练掌握Photoshop，会基本的切图操作；`,
    Front_endDevelopmentEngineerJobRequirements6: `6、应聘者需提供优秀设计作品2-3个。`,
    Front_endDevelopmentEngineerDuty1: ` 1、Web应用的设计与开发；`,
    Front_endDevelopmentEngineerDuty2: `2、Javascript数据处理；`,
    Front_endDevelopmentEngineerDuty3: `3、复杂Ajax交互开发；`,
    JAVAEngineerJobRequirements1: ` 1、专科以上学历，具备阅读英语技术开发手册等文档。`,
    JAVAEngineerJobRequirements2: `2、精通Java开发，熟悉J2EE体系结构，拥有2年以上实际开发经验，参与开发过2个以上大型项目。`,
    JAVAEngineerJobRequirements3: `3、熟练掌握HTML、javascript、CSS等web开发技术。`,
    JAVAEngineerJobRequirements4: `4、至少能够熟练使用一种主流数据库，对数据库有一定理解，熟练掌握SQL语句，有较好的数据库设计能力。`,
    JAVAEngineerJobRequirements5: `5、能熟练配置使用apache 、websphere、tomcat、weblogic 等。`,
    JAVAEngineerDuty1: `1、需求分析、系统设计工作，完成系统需求分析、设计说明书编写；`,
    JAVAEngineerDuty2: `2、负责按照要求完成各类设计文档，并参与开发。`,
    JAVAEngineerDuty3: `3、使用JAVA与数据库语言进行项目开发。`,
    enterpriseMailbox: `企业邮箱`

  }
}



// WEBPACK FOOTER //
// ./src/i18n/languages/CN.js